import {ComponentsConfigs} from '@gongxigames/framework/core/types/systemComponentsTypes';
import {modules} from '@gongxigames/framework/slotV2/ui/ui-ruby/modules';
// import {modules} from '@gongxigames/framework/slotV2/ui/ui-ruby/modules/index';
// import {UIKoalaModule} from '@gongxigames/framework/slotV2/ui/modules/uiKoala/UIKoalaModule';
// import {UIRubyAutoplayOptions} from '@gongxigames/framework/slotV2/ui/ui-ruby/uiRubyAutoplayOptions/UIRubyAutoplayOptionsModule';

export const rubyUIComponentsConfig: ComponentsConfigs = {
    modules: [
        // AutoplayOptionsModuleV1,

        // UIRubyModule,
        ...modules,
        // UIRubyAutoplayOptions
    ]
};